export function activateEscapeKeyListener (cb = Function, doc = document) {
  doc.addEventListener(ON_KEY_UP, escapeKeyHandler)
  callback = cb
}

export function deactivateEscapeKeyListener (doc = document) {
  doc.removeEventListener(ON_KEY_UP, escapeKeyHandler)
  callback = null
}

const escapeKeyHandler = (ev) => {
  const hasEscapeKey = ev.key === ESCAPE_KEY_TEXT
  const hasEscapeCode = (ev.keyCode || ev.which) === ESCAPE_KEY_CODE
  callback instanceof Function && (hasEscapeKey || hasEscapeCode) && callback()
}

const ESCAPE_KEY_TEXT = 'Escape'
const ESCAPE_KEY_CODE = 27
const ON_KEY_UP = 'keyup'
let callback = null
